import { render, staticRenderFns } from "./classrecord.vue?vue&type=template&id=aa4569ec&"
import script from "./classrecord.vue?vue&type=script&lang=js&"
export * from "./classrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports